import React, { useState } from "react";

export default React.memo(function PlayerImage({ className, id, alt }) {
    const [dynamicClassName, setDynamicClassName] = useState(className);
    const src = `https://s.hs-data.com/gfx/emblem/common/200x200/${parseInt(id)}.png`
    return (
        <img
            src={src}
            id={`bild-player-id-${id}`}
            className={dynamicClassName}
            alt={alt}
            // onError={({ currentTarget }) => handleError(currentTarget)}
            // onClick={onClick}
        />
    );
});
